import { render, staticRenderFns } from "./TransportsPage.vue?vue&type=template&id=1b3d080f&scoped=true&"
import script from "./TransportsPage.vue?vue&type=script&lang=js&"
export * from "./TransportsPage.vue?vue&type=script&lang=js&"
import style0 from "./TransportsPage.vue?vue&type=style&index=0&id=1b3d080f&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b3d080f",
  null
  
)

component.options.__file = "TransportsPage.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib'
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VDataTable } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VProgressLinear } from 'vuetify/lib'
import { VSnackbar } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {
  VAlert,
  VBtn,
  VCard,
  VCardTitle,
  VContainer,
  VDataTable,
  VFlex,
  VIcon,
  VLayout,
  VProgressLinear,
  VSnackbar,
  VSpacer,
  VTextField,
})
